import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center mb-4">
              <img src="/TheLab.svg" alt="The Lab" className="h-24 w-auto" />
            </div>
            <p className="text-gray-400 leading-relaxed">
              Premier football training for Quarterbacks, Running Backs, and Wide Receivers in Central New Jersey.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#home" className="text-gray-400 hover:text-cyan transition-colors">Home</a></li>
              <li><a href="#about" className="text-gray-400 hover:text-cyan transition-colors">About</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-cyan transition-colors">Services</a></li>
              <li><a href="#testimonials" className="text-gray-400 hover:text-cyan transition-colors">Testimonials</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-cyan transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Connect With Us</h4>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-cyan" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>Central New Jersey</span>
              </div>
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-cyan" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:thelabfbtraining@gmail.com" className="hover:text-cyan transition-colors">thelabfbtraining@gmail.com</a>
              </div>
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-cyan" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+17327354112" className="hover:text-cyan transition-colors">(732) 735-4112</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} The Lab Football Training. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
